const EventTypesTypes = {
  EVENT_TYPES_LOADING: "EVENT_TYPES_LOADING",
  GET_EVENT_TYPES_SUCCESS: "GET_EVENT_TYPES_SUCCESS",
  GET_SCROLL_EVENT_TYPES_SUCCESS: "GET_SCROLL_EVENT_TYPES_SUCCESS",
  GET_EVENT_TYPE_DETAILS_SUCCESS: "GET_EVENT_TYPE_DETAILS_SUCCESS",
  GET_EVENT_TYPE_SERVICES_SUCCESS: "GET_EVENT_TYPE_SERVICES_SUCCESS",
  GET_AVAILABLE_EVENT_SERVICES_SUCCESS: "GET_AVAILABLE_EVENT_SERVICES_SUCCESS",
};

export default EventTypesTypes;
